import { AbilityBuilder, PureAbility } from '@casl/ability';

function PSCLocking(user) {
    const { can, rules } = new AbilityBuilder(PureAbility);
    const {
        data: { region, permissions },
    } = user;

    if (region === 'PSC') {
        if (permissions.includes('ManagePickupLock')) can('mutate', 'pickup_lock');
        if (permissions.includes('ManageLabLock')) can('mutate', 'lab_lock');
    }

    return rules;
}

export default PSCLocking;
